var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseFilterIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.91 10.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #001109;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.15.88l9.88,9.88c.2.2.53.2.73,0s.2-.53,0-.73L.88.15c-.2-.2-.53-.2-.73,0S-.05.68.15.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.76.15c-.2-.2-.53-.2-.73,0L.15,10.03c-.2.2-.2.53,0,.73s.53.2.73,0L10.76.88c.2-.2.2-.53,0-.73Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilterIcon1);
export default __webpack_public_path__ + "static/media/closeFilterIcon_1.749c6c78e7a6b4273517190269250070.svg";
export { ForwardRef as ReactComponent };